import { Button, Col, Form, Input, Row } from "antd";
import { UserManagementResponseModel } from "api/repositories/userManagement/model/UserManagementResponse";
import CardComponent from "components/generalComponents/cardComponent/CardComponent";
import TableComponent from "components/generalComponents/tableComponent/TableComponent";
import { strings } from "utils/localizedStrings";
import UserManagementViewModel from "../viewModel/UserManagementViewModel";
import UserDetailsFeature from "./userDetails/UserDetailsFeature";

export type RowType = {
  key: string;
  name: string;
  phone: string;
  position: string;
  status: number;
};

const UserManagementFeature = () => {
  const {
    columns,
    dataSource,
    form,
    loading,
    page,
    pageSize,
    total,
    modal,
    selectedUser,
    setSelectedUser,
    handleReset,
    handleSearch,
    setModal,
    setPage,
    setPageSize,
  } = UserManagementViewModel();

  return (
    <CardComponent
      data={{
        extra: null,
        title: strings.GlobalLabels.User,
        mainTitle: strings.GlobalLabels.AccountManagement,
        children: (
          <Form form={form} layout="vertical">
            <Row gutter={[12, 5]}>
              {/* <Col span={24} lg={6}>
                <div className="truncate">{strings.GlobalLabels.Status}</div>
                <Form.Item name="status" initialValue={-1}>
                  <Select
                    options={[
                      { label: strings.GlobalLabels.All, value: -1 },
                      { label: strings.GlobalLabels.Active, value: 0 },
                      { label: strings.GlobalLabels.Inactive, value: 1 },
                    ]}
                    onChange={() => handleSearch()}
                  />
                </Form.Item>
              </Col> */}
              <Col span={24} lg={8}>
                <div className="truncate">
                  {strings.UserManagement.Columns.Email}
                </div>
                <Form.Item name="email" initialValue="">
                  <Input placeholder={strings.GlobalPlaceholder.Email} />
                </Form.Item>
              </Col>
              <Col span={24} lg={8}>
                <div className="truncate">{strings.GlobalLabels.Phone}</div>
                <Form.Item name="phone">
                  <Input placeholder={strings.GlobalPlaceholder.Phone} />
                </Form.Item>
              </Col>
              <Col span={24} lg={8}>
                <div className="truncate">
                  {strings.UserManagement.Columns.FullName}
                </div>
                <Form.Item name="fullName">
                  <Input placeholder={strings.GlobalPlaceholder.Name} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full">
                  <Button
                    className="h-10 w-full rounded-md"
                    style={{
                      backgroundColor: "#8E9196",
                      color: "#fff",
                      border: "none",
                      borderRadius: 10,
                    }}
                    onClick={handleReset}
                  >
                    {strings.GlobalLabels.Redo}
                  </Button>
                  <Button
                    className="h-10 w-full rounded-md"
                    type="primary"
                    style={{
                      backgroundColor: "#0A7AFF",
                      border: "none",
                      borderRadius: 10,
                    }}
                    onClick={handleSearch}
                  >
                    {strings.GlobalLabels.Search}
                  </Button>
                </div>
              </Col>
              <TableComponent<UserManagementResponseModel>
                data={{
                  columns: columns as any,
                  dataSource,
                  loading,
                  loadingTitle: "Loading...",
                  page,
                  pageSize,
                  total,
                  totalTitle: strings.GlobalLabels.Total || "Tổng",
                  scroll: { x: 1500, y: 520 },
                  handleTableChange: (p?: any) => {
                    if (p) {
                      setPage((p?.current || 1) - 1);
                      setPageSize(p?.pageSize || 10);
                    }
                  },
                }}
              />
            </Row>
            <UserDetailsFeature
              data={{
                visible: modal,
                user: selectedUser,
                onClose: () => {
                  setModal(false);
                  setSelectedUser(null);
                },
              }}
            />
          </Form>
        ),
      }}
    />
  );
};

export default UserManagementFeature;
